export const sentryConfig = {
  devDSN: "https://736804c2140b40e086ac558fcf7e9554@sentry.io/149589",
  prodDSN: "https://5cfd821e931e473f8d84d37d495dcdad@sentry.io/149587"
}


// WEBPACK FOOTER //
// ./src/core/sentry/config.js